import { Services } from '@sigma-frontend-libs/commons'

import { components, labelModes } from '@/utils'

import buttonFilter from '@/components/button/filter'
import filterDate from '@/components/filter/date'
import selectorOwner from '@/components/selector/owner'
import typeField from '@/components/services/report-manager/commons/form/type'
import { serviceNameKebabCase } from '@/components/services/report-manager/recurrent/utils'

function renderDateFilter(h) {
  return h(
    filterDate,
    {
      props: {
        value: this.proxy.createdAt,
        preset: this.proxy.createdAtPreset,
        presets: true,
        clearable: true,
        backendGeneration: 'nest'
      },
      on: {
        input: event => {
          this.proxy.createdAt = event
        },
        preset: event => {
          this.proxy.createdAtPreset = event
        }
      }
    }
  )
}

function renderNameField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.name,
        label: this.getTranslate(`${Services['report-manager']}.labels.name`),
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.name = event
        }
      }
    }
  )
}
function renderTypeField(h) {
  return h(
    typeField,
    {
      props: {
        value: this.proxy.type,
        labelMode: labelModes.hidden,
        clearable: true,
        required: false,
        showError: false
      },
      on: {
        input: event => {
          this.proxy.type = event
        }
      }
    }
  )
}
function renderStatusField(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.status,
        label: this.getTranslate(`${Services['report-manager']}.labels.status`),
        items: this.statuses,
        labelMode: labelModes.hidden,
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.status = event
        }
      }
    }
  )
}
function renderOwnerField(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.ownerId,
        labelMode: labelModes.hidden,
        dense: true
      },
      on: {
        input: event => {
          this.proxy.ownerId = event
        }
      }
    }
  )
}
function renderFields(h) {
  return [
    renderNameField.call(this, h),
    renderTypeField.call(this, h),
    renderStatusField.call(this, h),
    renderOwnerField.call(this, h)
  ]
}

function renderButtonFilter(h) {
  return h(
    buttonFilter,
    {
      props: {
        value: this.proxy,
        defaultValue: this.defaultFilter
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    },
    renderFields.call(this, h)
  )
}

function renderContentByViewport(h) {
  if (this.viewport.breakpoint.lgUp) {
    return renderButtonFilter.call(this, h)
  } else {
    return h(
      'div',
      {
        class: 'grid grid-gap--8'
      },
      renderFields.call(this, h)
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-filter`
    },
    [
      renderDateFilter.call(this, h),
      renderContentByViewport.call(this, h)
    ]
  )
}
